module.exports = __webpack_public_path__ + "static/img/4.555aaab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news29/4.png
// module id = P1d6
// module chunks = 1